<script>
  export let totalItems = 0;
  export let itemsPerPage = 10;
  export let currentPage = 1;
  export let onPageChange = (page) => {};
  let pages = [];

  // Update totalPages when totalItems or itemsPerPage change
  $: totalPages = Math.ceil(totalItems / itemsPerPage);

  // Function to handle page change
  function changePage(page) {
    if (page < 1 || page > totalPages) return;
    currentPage = page;
    onPageChange(currentPage);
  }

  

  $: {      

    pages = [];
    let startPage = Math.max(currentPage - 5, 1);
    let endPage = Math.min(currentPage + 5, totalPages);

    console.log(totalPages,currentPage,startPage,endPage)

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
  }
</script>

<style>
  .pagination {
    display: flex;
    list-style: none;
    padding: 0;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    padding: 10px;
    margin: 0;
  }

  .page-item {
    margin: 0 5px;
  }

  .page-item button {
    padding: 5px 10px;
    border: 1px solid #ccc;
    background: none;
    border-radius: 3px;;
    cursor: pointer;
  }

  .page-item button.active {
    font-weight: bold;
    background: #ddd;
  }

  .page-item button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
</style>

<ul class="pagination">
  <li class="page-item">
    <button on:click={() => changePage(1)} disabled={currentPage === 1}>
      ראשון
    </button>
  </li>
  <li class="page-item">
    <button on:click={() => changePage(currentPage - 1)} disabled={currentPage === 1}>
      הקודם
    </button>
  </li>
  {#each pages as page}
    <li class="page-item">
      <button
        class:active={currentPage === page}
        on:click={() => changePage(page)}
      >
        {page}
      </button>
    </li>
  {/each}
  <li class="page-item">
    <button on:click={() => changePage(currentPage + 1)} disabled={currentPage === totalPages}>
      הבא
    </button>
  </li>
  <li class="page-item">
    <button on:click={() => changePage(totalPages)} disabled={currentPage === totalPages}>
      אחרון
    </button>
  </li>
</ul>
